/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { parseJwt } from "../../../core/jwt/jwt.util";
import { LoadingService } from "../../../core/loader/loading.service";
import { NotificationService } from "../../../shared/components/notification/notification.service";
import { passwordValidator } from "../../../shared/utils/helpers/common.helper";
import { LoginLayoutData } from "../index-layout/index-layout.type";

@Component({
  selector: "app-reset",
  templateUrl: "./reset.component.html",
  styleUrls: ["./reset.component.scss"],
})
export class ResetComponent implements OnInit {
  readonly environment = environment;
  resetPasswordForm: FormGroup;
  hostname: string;
  token: string;
  email: string;
  loading$ = this.loader.loading$;
  submitted = false;
  hide = true;
  hideConfirm = true;
  layoutData: LoginLayoutData = {
    image: "assets/GlobeLogo.svg",
    title: "Reset Password",
  };

  constructor(
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private router: Router,
    private loader: LoadingService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public location: Location,
  ) {
    this.hostname = window.location.hostname;
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group(
      {
        newPassword: ["", [Validators.required, Validators.minLength(5)]],
        confirmPassword: ["", [Validators.required]],
      },
      {
        validators: [passwordValidator("newPassword", "confirmPassword")],
      },
    );
    this.token = this.route.snapshot.queryParams["token"];
    if (!this.token) {
      this.router.navigate(["/login"]);
      return;
    }
    try {
      this.email = parseJwt(this.token).sub;
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  goBack() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.loader.show();

    const data = {
      token: this.token,
      email: this.email,
      newPassword: this.resetPasswordForm.value?.newPassword,
    };

    this.authenticationService
      .resetPassword(data)
      .subscribe(
        () => {
          this.notificationService.success("Password has been updated successfully");
          this.router.navigate(["/login"]);
        },
        (err) => {
          this.notificationService.error(
            err || "The password reset link has expired. Please click forgot password to receive a new link.",
          );
        },
      )
      .add(() => this.loader.hide());
  }

  /** shortcut for form controls */
  get f() {
    return this.resetPasswordForm.controls;
  }
}
